<template>
  <BaseModal
    :heading="currentStep === 3 ? $t('subscription.cancelation_flow.success_treatwell_offer.heading') : $t('subscription.cancelation_flow.free_plan_offer')"
    small
    @close="close"
  >
    <BaseSlider :step="currentStep">
      <template #1>
        <Step1 />
      </template>
      <template #2>
        <Step2 />
      </template>
      <template #3>
        <Step3 />
      </template>
    </BaseSlider>
    <template #footer>
      <BaseButton
        v-if="currentStep !== 3"
        color="inverted"
        @click="goBack"
        v-test="'cancel-flow-try-for-free-back'"
      >
        {{ $t('global.back') }}
      </BaseButton>
      <BaseButton
        @click="submit"
        :loading="loading"
        v-test="'cancel-flow-try-for-free-submit'"
      >
        {{ currentStep === 3 ? $t('subscription.cancelation_flow.success_treatwell_offer.cta') : $t('subscription.cancelation_flow.actions.accept_offer') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { CHANGE_STRIPE_SUBSCRIPTION_MUTATION } from '../graphql';
import Step1 from './Step1.vue';
import Step3 from './Step3.vue';
import Step2 from './step2/index.vue';

const emit = defineEmits(['close', 'back']);

const currentStep = ref<number>(1);

const { mutate, loading } = useMutation(CHANGE_STRIPE_SUBSCRIPTION_MUTATION);
const submit = () => {
  if (currentStep.value === 1) {
    currentStep.value = 2;
  } else if (currentStep.value === 2) {
    mutate({
      input: {
        plan: 'LITE',
        period: 'MONTH',
      },
    }).then(() => {
      currentStep.value = 3;
    });
  } else if (currentStep.value === 3) {
    emit('close');
  }
};

const goBack = () => {
  if (currentStep.value === 1) {
    emit('back');
  } else {
    currentStep.value--;
  }
};

const close = () => {
  emit('close');
};
</script>
